import { PALETTE as P } from "../../tokens";

/**
 * FoundationsFill — "One-Line Fill" (optional short text).
 *
 * Always optional — never gates progress. The container keeps Submit
 * enabled regardless of whether this has content.
 *
 * Props:
 *   placeholder  — input placeholder
 *   onTextChange — (text) => void
 *   value        — current text
 */
export default function FoundationsFill({ placeholder, onTextChange, value = "" }) {
  return (
    <div>
      <input
        type="text"
        value={value}
        onChange={(e) => onTextChange(e.target.value)}
        placeholder={placeholder || ""}
        style={{
          width: "100%",
          padding: "14px 16px",
          borderRadius: 12,
          border: `1px solid ${P.border}`,
          background: P.bg,
          color: P.text,
          fontSize: 15,
          fontFamily: "inherit",
          outline: "none",
        }}
      />
      <div
        style={{
          fontSize: 12,
          color: P.textMute,
          marginTop: 10,
          fontStyle: "italic",
        }}
      >
        Optional — skip if nothing comes to mind.
      </div>
    </div>
  );
}
